export const second_level_geo = {
  geocode: [
    {
      provID: 1,
      value: 11,
      parentID: 0,
      level: 1,
      label: "北京市",
      children: [
        { cityID: 2, value: 1101, parentID: 11, level: 2, label: "市辖区" },
        { cityID: 300, value: 1102, parentID: 11, level: 2, label: "县" },
      ],
    },
    {
      provID: 338,
      value: 12,
      parentID: 0,
      level: 1,
      label: "天津市",
      children: [
        { cityID: 339, value: 1201, parentID: 12, level: 2, label: "市辖区" },
        { cityID: 569, value: 1202, parentID: 12, level: 2, label: "市辖县" },
      ],
    },
    {
      provID: 636,
      value: 13,
      parentID: 0,
      level: 1,
      label: "河北省",
      children: [
        { cityID: 637, value: 1301, parentID: 13, level: 2, label: "石家庄市" },
        { cityID: 936, value: 1302, parentID: 13, level: 2, label: "唐山市" },
        {
          cityID: 1188,
          value: 1303,
          parentID: 13,
          level: 2,
          label: "秦皇岛市",
        },
        { cityID: 1291, value: 1304, parentID: 13, level: 2, label: "邯郸市" },
        { cityID: 1554, value: 1305, parentID: 13, level: 2, label: "邢台市" },
        { cityID: 1772, value: 1306, parentID: 13, level: 2, label: "保定市" },
        {
          cityID: 2142,
          value: 1307,
          parentID: 13,
          level: 2,
          label: "张家口市",
        },
        { cityID: 2400, value: 1308, parentID: 13, level: 2, label: "承德市" },
        { cityID: 2629, value: 1309, parentID: 13, level: 2, label: "沧州市" },
        { cityID: 2849, value: 1310, parentID: 13, level: 2, label: "廊坊市" },
        { cityID: 2968, value: 1311, parentID: 13, level: 2, label: "衡水市" },
      ],
    },
    {
      provID: 3102,
      value: 14,
      parentID: 0,
      level: 1,
      label: "山西",
      children: [
        { cityID: 3103, value: 1401, parentID: 14, level: 2, label: "太原市" },
        { cityID: 3224, value: 1402, parentID: 14, level: 2, label: "大同市" },
        { cityID: 3379, value: 1403, parentID: 14, level: 2, label: "阳泉市" },
        { cityID: 3431, value: 1404, parentID: 14, level: 2, label: "长治市" },
        { cityID: 3597, value: 1405, parentID: 14, level: 2, label: "晋城市" },
        { cityID: 3690, value: 1406, parentID: 14, level: 2, label: "朔州市" },
        { cityID: 3776, value: 1407, parentID: 14, level: 2, label: "晋中市" },
        { cityID: 3925, value: 1408, parentID: 14, level: 2, label: "运城市" },
        { cityID: 4093, value: 1409, parentID: 14, level: 2, label: "忻州市" },
        { cityID: 4304, value: 1410, parentID: 14, level: 2, label: "临汾市" },
        { cityID: 4494, value: 1411, parentID: 14, level: 2, label: "吕梁市" },
      ],
    },
    {
      provID: 4670,
      value: 15,
      parentID: 0,
      level: 1,
      label: "内蒙古自治区",
      children: [
        {
          cityID: 4671,
          value: 1501,
          parentID: 15,
          level: 2,
          label: "呼和浩特市",
        },
        { cityID: 4759, value: 1502, parentID: 15, level: 2, label: "包头市" },
        { cityID: 4849, value: 1503, parentID: 15, level: 2, label: "乌海市" },
        { cityID: 4874, value: 1504, parentID: 15, level: 2, label: "赤峰市" },
        { cityID: 5029, value: 1505, parentID: 15, level: 2, label: "通辽市" },
        {
          cityID: 5162,
          value: 1506,
          parentID: 15,
          level: 2,
          label: "鄂尔多斯市",
        },
        {
          cityID: 5236,
          value: 1507,
          parentID: 15,
          level: 2,
          label: "呼伦贝尔市",
        },
        {
          cityID: 5418,
          value: 1508,
          parentID: 15,
          level: 2,
          label: "巴彦淖尔市",
        },
        {
          cityID: 5505,
          value: 1509,
          parentID: 15,
          level: 2,
          label: "乌兰察布市",
        },
        { cityID: 5616, value: 1522, parentID: 15, level: 2, label: "兴安盟" },
        {
          cityID: 5702,
          value: 1525,
          parentID: 15,
          level: 2,
          label: "锡林郭勒盟",
        },
        {
          cityID: 5799,
          value: 1529,
          parentID: 15,
          level: 2,
          label: "阿拉善盟",
        },
      ],
    },
    {
      provID: 5827,
      value: 21,
      parentID: 0,
      level: 1,
      label: "辽宁省",
      children: [
        { cityID: 5828, value: 2101, parentID: 21, level: 2, label: "沈阳市" },
        { cityID: 6088, value: 2102, parentID: 21, level: 2, label: "大连市" },
        { cityID: 6266, value: 2103, parentID: 21, level: 2, label: "鞍山市" },
        { cityID: 6384, value: 2104, parentID: 21, level: 2, label: "抚顺市" },
        { cityID: 6476, value: 2105, parentID: 21, level: 2, label: "本溪市" },
        { cityID: 6542, value: 2106, parentID: 21, level: 2, label: "丹东市" },
        { cityID: 6643, value: 2107, parentID: 21, level: 2, label: "锦州市" },
        { cityID: 6771, value: 2108, parentID: 21, level: 2, label: "营口市" },
        { cityID: 6851, value: 2109, parentID: 21, level: 2, label: "阜新市" },
        { cityID: 6955, value: 2110, parentID: 21, level: 2, label: "辽阳市" },
        { cityID: 7024, value: 2111, parentID: 21, level: 2, label: "盘锦市" },
        { cityID: 7088, value: 2112, parentID: 21, level: 2, label: "铁岭市" },
        { cityID: 7208, value: 2113, parentID: 21, level: 2, label: "朝阳市" },
        {
          cityID: 7391,
          value: 2114,
          parentID: 21,
          level: 2,
          label: "葫芦岛市",
        },
      ],
    },
    {
      provID: 7531,
      value: 22,
      parentID: 0,
      level: 1,
      label: "吉林省",
      children: [
        { cityID: 7532, value: 2201, parentID: 22, level: 2, label: "长春市" },
        { cityID: 7706, value: 2202, parentID: 22, level: 2, label: "吉林市" },
        { cityID: 7868, value: 2203, parentID: 22, level: 2, label: "四平市" },
        { cityID: 7986, value: 2204, parentID: 22, level: 2, label: "辽源市" },
        { cityID: 8037, value: 2205, parentID: 22, level: 2, label: "通化市" },
        { cityID: 8144, value: 2206, parentID: 22, level: 2, label: "白山市" },
        { cityID: 8216, value: 2207, parentID: 22, level: 2, label: "松原市" },
        { cityID: 8333, value: 2208, parentID: 22, level: 2, label: "白城市" },
        {
          cityID: 8445,
          value: 2224,
          parentID: 22,
          level: 2,
          label: "延边朝鲜族自治州",
        },
      ],
    },
    {
      provID: 8558,
      value: 23,
      parentID: 0,
      level: 1,
      label: "黑龙江省",
      children: [
        {
          cityID: 8559,
          value: 2301,
          parentID: 23,
          level: 2,
          label: "哈尔滨市",
        },
        {
          cityID: 8884,
          value: 2302,
          parentID: 23,
          level: 2,
          label: "齐齐哈尔市",
        },
        { cityID: 9117, value: 2303, parentID: 23, level: 2, label: "鸡西市" },
        { cityID: 9222, value: 2304, parentID: 23, level: 2, label: "鹤岗市" },
        {
          cityID: 9296,
          value: 2305,
          parentID: 23,
          level: 2,
          label: "双鸭山市",
        },
        { cityID: 9419, value: 2306, parentID: 23, level: 2, label: "大庆市" },
        { cityID: 9553, value: 2307, parentID: 23, level: 2, label: "伊春市" },
        {
          cityID: 9785,
          value: 2308,
          parentID: 23,
          level: 2,
          label: "佳木斯市",
        },
        {
          cityID: 9930,
          value: 2309,
          parentID: 23,
          level: 2,
          label: "七台河市",
        },
        {
          cityID: 9981,
          value: 2310,
          parentID: 23,
          level: 2,
          label: "牡丹江市",
        },
        { cityID: 10084, value: 2311, parentID: 23, level: 2, label: "黑河市" },
        { cityID: 10252, value: 2312, parentID: 23, level: 2, label: "绥化市" },
        {
          cityID: 10483,
          value: 2327,
          parentID: 23,
          level: 2,
          label: "大兴安岭地区",
        },
      ],
    },
    {
      provID: 10543,
      value: 31,
      parentID: 0,
      level: 1,
      label: "上海市",
      children: [
        { cityID: 10544, value: 3101, parentID: 31, level: 2, label: "市辖区" },
        { cityID: 10779, value: 3102, parentID: 31, level: 2, label: "县" },
      ],
    },
    {
      provID: 10808,
      value: 32,
      parentID: 0,
      level: 1,
      label: "江苏省",
      children: [
        { cityID: 10809, value: 3201, parentID: 32, level: 2, label: "南京市" },
        { cityID: 10960, value: 3202, parentID: 32, level: 2, label: "无锡市" },
        { cityID: 11067, value: 3203, parentID: 32, level: 2, label: "徐州市" },
        { cityID: 11245, value: 3204, parentID: 32, level: 2, label: "常州市" },
        { cityID: 11348, value: 3205, parentID: 32, level: 2, label: "苏州市" },
        { cityID: 11482, value: 3206, parentID: 32, level: 2, label: "南通市" },
        {
          cityID: 11663,
          value: 3207,
          parentID: 32,
          level: 2,
          label: "连云港市",
        },
        { cityID: 11786, value: 3208, parentID: 32, level: 2, label: "淮安市" },
        { cityID: 11947, value: 3209, parentID: 32, level: 2, label: "盐城市" },
        { cityID: 12135, value: 3210, parentID: 32, level: 2, label: "扬州市" },
        { cityID: 12249, value: 3211, parentID: 32, level: 2, label: "镇江市" },
        { cityID: 12343, value: 3212, parentID: 32, level: 2, label: "泰州市" },
        { cityID: 12475, value: 3213, parentID: 32, level: 2, label: "宿迁市" },
      ],
    },
    {
      provID: 12596,
      value: 33,
      parentID: 0,
      level: 1,
      label: "浙江省",
      children: [
        { cityID: 12597, value: 3301, parentID: 33, level: 2, label: "杭州市" },
        { cityID: 12813, value: 3302, parentID: 33, level: 2, label: "宁波市" },
        { cityID: 12974, value: 3303, parentID: 33, level: 2, label: "温州市" },
        { cityID: 13280, value: 3304, parentID: 33, level: 2, label: "嘉兴市" },
        { cityID: 13364, value: 3305, parentID: 33, level: 2, label: "湖州市" },
        { cityID: 13437, value: 3306, parentID: 33, level: 2, label: "绍兴市" },
        { cityID: 13564, value: 3307, parentID: 33, level: 2, label: "金华市" },
        { cityID: 13726, value: 3308, parentID: 33, level: 2, label: "衢州市" },
        { cityID: 13840, value: 3309, parentID: 33, level: 2, label: "舟山市" },
        { cityID: 13890, value: 3310, parentID: 33, level: 2, label: "台州市" },
        { cityID: 14033, value: 3311, parentID: 33, level: 2, label: "丽水市" },
      ],
    },
    {
      provID: 14234,
      value: 34,
      parentID: 0,
      level: 1,
      label: "安徽省",
      children: [
        { cityID: 14235, value: 3401, parentID: 34, level: 2, label: "合肥市" },
        { cityID: 14351, value: 3402, parentID: 34, level: 2, label: "芜湖市" },
        { cityID: 14410, value: 3403, parentID: 34, level: 2, label: "蚌埠市" },
        { cityID: 14500, value: 3404, parentID: 34, level: 2, label: "淮南市" },
        {
          cityID: 14575,
          value: 3405,
          parentID: 34,
          level: 2,
          label: "马鞍山市",
        },
        { cityID: 14612, value: 3406, parentID: 34, level: 2, label: "淮北市" },
        { cityID: 14653, value: 3407, parentID: 34, level: 2, label: "铜陵市" },
        { cityID: 14687, value: 3408, parentID: 34, level: 2, label: "安庆市" },
        { cityID: 14887, value: 3410, parentID: 34, level: 2, label: "黄山市" },
        { cityID: 15005, value: 3411, parentID: 34, level: 2, label: "滁州市" },
        { cityID: 15194, value: 3412, parentID: 34, level: 2, label: "阜阳市" },
        { cityID: 15378, value: 3413, parentID: 34, level: 2, label: "宿州市" },
        { cityID: 15499, value: 3414, parentID: 34, level: 2, label: "巢湖市" },
        { cityID: 15586, value: 3415, parentID: 34, level: 2, label: "六安市" },
        { cityID: 15764, value: 3416, parentID: 34, level: 2, label: "亳州市" },
        { cityID: 15871, value: 3417, parentID: 34, level: 2, label: "池州市" },
        { cityID: 15958, value: 3418, parentID: 34, level: 2, label: "宣城市" },
      ],
    },
    {
      provID: 16068,
      value: 35,
      parentID: 0,
      level: 1,
      label: "福建省",
      children: [
        { cityID: 16069, value: 3501, parentID: 35, level: 2, label: "福州市" },
        { cityID: 16278, value: 3502, parentID: 35, level: 2, label: "厦门市" },
        { cityID: 16348, value: 3503, parentID: 35, level: 2, label: "莆田市" },
        { cityID: 16412, value: 3504, parentID: 35, level: 2, label: "三明市" },
        { cityID: 16572, value: 3505, parentID: 35, level: 2, label: "泉州市" },
        { cityID: 16754, value: 3506, parentID: 35, level: 2, label: "漳州市" },
        { cityID: 16924, value: 3507, parentID: 35, level: 2, label: "南平市" },
        { cityID: 17077, value: 3508, parentID: 35, level: 2, label: "龙岩市" },
        {
          cityID: 17219,
          value: 3509,
          parentID: 35,
          level: 2,
          label: "宁德市　",
        },
      ],
    },
    {
      provID: 17359,
      value: 36,
      parentID: 0,
      level: 1,
      label: "江西省",
      children: [
        { cityID: 17360, value: 3601, parentID: 36, level: 2, label: "南昌市" },
        {
          cityID: 17508,
          value: 3602,
          parentID: 36,
          level: 2,
          label: "景德镇市",
        },
        { cityID: 17589, value: 3603, parentID: 36, level: 2, label: "萍乡市" },
        { cityID: 17651, value: 3604, parentID: 36, level: 2, label: "九江市" },
        { cityID: 17894, value: 3605, parentID: 36, level: 2, label: "新余市" },
        { cityID: 17934, value: 3606, parentID: 36, level: 2, label: "鹰潭市" },
        { cityID: 17999, value: 3607, parentID: 36, level: 2, label: "赣州市" },
        { cityID: 18330, value: 3608, parentID: 36, level: 2, label: "吉安市" },
        { cityID: 18598, value: 3609, parentID: 36, level: 2, label: "宜春市" },
        { cityID: 18829, value: 3610, parentID: 36, level: 2, label: "抚州市" },
        { cityID: 19024, value: 3611, parentID: 36, level: 2, label: "上饶市" },
      ],
    },
    {
      provID: 19280,
      value: 37,
      parentID: 0,
      level: 1,
      label: "山东省",
      children: [
        { cityID: 19281, value: 3701, parentID: 37, level: 2, label: "济南市" },
        { cityID: 19421, value: 3702, parentID: 37, level: 2, label: "青岛市" },
        { cityID: 19608, value: 3703, parentID: 37, level: 2, label: "淄博市" },
        { cityID: 19724, value: 3704, parentID: 37, level: 2, label: "枣庄市" },
        { cityID: 19796, value: 3705, parentID: 37, level: 2, label: "东营市" },
        { cityID: 19846, value: 3706, parentID: 37, level: 2, label: "烟台市" },
        { cityID: 20012, value: 3707, parentID: 37, level: 2, label: "潍坊市" },
        { cityID: 20216, value: 3708, parentID: 37, level: 2, label: "济宁市" },
        { cityID: 20386, value: 3709, parentID: 37, level: 2, label: "泰安市" },
        { cityID: 20480, value: 3710, parentID: 37, level: 2, label: "威海市" },
        { cityID: 20558, value: 3711, parentID: 37, level: 2, label: "日照市" },
        { cityID: 20618, value: 3712, parentID: 37, level: 2, label: "莱芜市" },
        { cityID: 20642, value: 3713, parentID: 37, level: 2, label: "临沂市" },
        { cityID: 20836, value: 3714, parentID: 37, level: 2, label: "德州市" },
        { cityID: 20981, value: 3715, parentID: 37, level: 2, label: "聊城市" },
        { cityID: 21123, value: 3716, parentID: 37, level: 2, label: "滨州市" },
        { cityID: 21218, value: 3717, parentID: 37, level: 2, label: "菏泽市" },
      ],
    },
    {
      provID: 21387,
      value: 41,
      parentID: 0,
      level: 1,
      label: "河南省",
      children: [
        { cityID: 21388, value: 4101, parentID: 41, level: 2, label: "郑州市" },
        { cityID: 21575, value: 4102, parentID: 41, level: 2, label: "开封市" },
        { cityID: 21711, value: 4103, parentID: 41, level: 2, label: "洛阳市" },
        {
          cityID: 21913,
          value: 4104,
          parentID: 41,
          level: 2,
          label: "平顶山市",
        },
        { cityID: 22058, value: 4105, parentID: 41, level: 2, label: "安阳市" },
        { cityID: 22206, value: 4106, parentID: 41, level: 2, label: "鹤壁市" },
        { cityID: 22251, value: 4107, parentID: 41, level: 2, label: "新乡市" },
        { cityID: 22423, value: 4108, parentID: 41, level: 2, label: "焦作市" },
        { cityID: 22558, value: 4109, parentID: 41, level: 2, label: "濮阳市" },
        { cityID: 22655, value: 4110, parentID: 41, level: 2, label: "许昌市" },
        { cityID: 22762, value: 4111, parentID: 41, level: 2, label: "漯河市" },
        {
          cityID: 22824,
          value: 4112,
          parentID: 41,
          level: 2,
          label: "三门峡市",
        },
        { cityID: 22910, value: 4113, parentID: 41, level: 2, label: "南阳市" },
        { cityID: 23170, value: 4114, parentID: 41, level: 2, label: "商丘市" },
        { cityID: 23372, value: 4115, parentID: 41, level: 2, label: "信阳市" },
        { cityID: 23589, value: 4116, parentID: 41, level: 2, label: "周口市" },
        {
          cityID: 23818,
          value: 4117,
          parentID: 41,
          level: 2,
          label: "驻马店市",
        },
      ],
    },
    {
      provID: 24022,
      value: 42,
      parentID: 0,
      level: 1,
      label: "湖北省",
      children: [
        { cityID: 24023, value: 4201, parentID: 42, level: 2, label: "武汉市" },
        { cityID: 24224, value: 4202, parentID: 42, level: 2, label: "黄石市" },
        { cityID: 24291, value: 4203, parentID: 42, level: 2, label: "十堰市" },
        { cityID: 24453, value: 4205, parentID: 42, level: 2, label: "宜昌市" },
        { cityID: 24580, value: 4206, parentID: 42, level: 2, label: "襄樊市" },
        { cityID: 24706, value: 4207, parentID: 42, level: 2, label: "鄂州市" },
        { cityID: 24737, value: 4208, parentID: 42, level: 2, label: "荆门市" },
        { cityID: 24816, value: 4209, parentID: 42, level: 2, label: "孝感市" },
        { cityID: 24949, value: 4210, parentID: 42, level: 2, label: "荆州市" },
        { cityID: 25086, value: 4211, parentID: 42, level: 2, label: "黄冈市" },
        { cityID: 25249, value: 4212, parentID: 42, level: 2, label: "咸宁市" },
        { cityID: 25335, value: 4213, parentID: 42, level: 2, label: "随州市" },
        { cityID: 25388, value: 4228, parentID: 42, level: 2, label: "恩施州" },
        {
          cityID: 25487,
          value: 4290,
          parentID: 42,
          level: 2,
          label: "省直辖行政单位",
        },
      ],
    },
    {
      provID: 25579,
      value: 43,
      parentID: 0,
      level: 1,
      label: "湖南省",
      children: [
        { cityID: 25580, value: 4301, parentID: 43, level: 2, label: "长沙市" },
        { cityID: 25758, value: 4302, parentID: 43, level: 2, label: "株洲市" },
        { cityID: 25912, value: 4303, parentID: 43, level: 2, label: "湘潭市" },
        { cityID: 26001, value: 4304, parentID: 43, level: 2, label: "衡阳市" },
        { cityID: 26242, value: 4305, parentID: 43, level: 2, label: "邵阳市" },
        { cityID: 26485, value: 4306, parentID: 43, level: 2, label: "岳阳市" },
        { cityID: 26683, value: 4307, parentID: 43, level: 2, label: "常德市" },
        {
          cityID: 26925,
          value: 4308,
          parentID: 43,
          level: 2,
          label: "张家界市",
        },
        { cityID: 27038, value: 4309, parentID: 43, level: 2, label: "益阳市" },
        { cityID: 27147, value: 4310, parentID: 43, level: 2, label: "郴州市" },
        { cityID: 27418, value: 4311, parentID: 43, level: 2, label: "永州市" },
        { cityID: 27650, value: 4312, parentID: 43, level: 2, label: "怀化市" },
        { cityID: 27963, value: 4313, parentID: 43, level: 2, label: "娄底市" },
        {
          cityID: 28065,
          value: 4331,
          parentID: 43,
          level: 2,
          label: "湘西土家族苗族自治州",
        },
      ],
    },
    {
      provID: 28240,
      value: 44,
      parentID: 0,
      level: 1,
      label: "广东省",
      children: [
        { cityID: 28241, value: 4401, parentID: 44, level: 2, label: "广州市" },
        { cityID: 28421, value: 4402, parentID: 44, level: 2, label: "韶关市" },
        { cityID: 28558, value: 4403, parentID: 44, level: 2, label: "深圳市" },
        { cityID: 28626, value: 4404, parentID: 44, level: 2, label: "珠海市" },
        { cityID: 28659, value: 4405, parentID: 44, level: 2, label: "汕头市" },
        { cityID: 28737, value: 4406, parentID: 44, level: 2, label: "佛山市" },
        { cityID: 28785, value: 4407, parentID: 44, level: 2, label: "江门市" },
        { cityID: 28880, value: 4408, parentID: 44, level: 2, label: "湛江市" },
        { cityID: 29026, value: 4409, parentID: 44, level: 2, label: "茂名市" },
        { cityID: 29159, value: 4412, parentID: 44, level: 2, label: "肇庆市" },
        { cityID: 29282, value: 4413, parentID: 44, level: 2, label: "惠州市" },
        { cityID: 29371, value: 4414, parentID: 44, level: 2, label: "梅州市" },
        { cityID: 29498, value: 4415, parentID: 44, level: 2, label: "汕尾市" },
        { cityID: 29568, value: 4416, parentID: 44, level: 2, label: "河源市" },
        { cityID: 29679, value: 4417, parentID: 44, level: 2, label: "阳江市" },
        { cityID: 29755, value: 4418, parentID: 44, level: 2, label: "清远市" },
        { cityID: 29855, value: 4419, parentID: 44, level: 2, label: "东莞市" },
        { cityID: 29890, value: 4420, parentID: 44, level: 2, label: "中山市" },
        { cityID: 29915, value: 4451, parentID: 44, level: 2, label: "潮州市" },
        { cityID: 29977, value: 4452, parentID: 44, level: 2, label: "揭阳市" },
        { cityID: 30086, value: 4453, parentID: 44, level: 2, label: "云浮市" },
      ],
    },
    {
      provID: 30164,
      value: 45,
      parentID: 0,
      level: 1,
      label: "广西壮族自治区",
      children: [
        { cityID: 30165, value: 4501, parentID: 45, level: 2, label: "南宁市" },
        { cityID: 30319, value: 4502, parentID: 45, level: 2, label: "柳州市" },
        { cityID: 30448, value: 4503, parentID: 45, level: 2, label: "桂林市" },
        { cityID: 30613, value: 4504, parentID: 45, level: 2, label: "梧州市" },
        { cityID: 30688, value: 4505, parentID: 45, level: 2, label: "北海市" },
        {
          cityID: 30724,
          value: 4506,
          parentID: 45,
          level: 2,
          label: "防城港市",
        },
        { cityID: 30762, value: 4507, parentID: 45, level: 2, label: "钦州市" },
        { cityID: 30834, value: 4508, parentID: 45, level: 2, label: "贵港市" },
        { cityID: 30915, value: 4509, parentID: 45, level: 2, label: "玉林市" },
        { cityID: 31033, value: 4510, parentID: 45, level: 2, label: "百色市" },
        { cityID: 31184, value: 4511, parentID: 45, level: 2, label: "贺州市" },
        { cityID: 31249, value: 4512, parentID: 45, level: 2, label: "河池市" },
        { cityID: 31401, value: 4513, parentID: 45, level: 2, label: "来宾市" },
        { cityID: 31478, value: 4514, parentID: 45, level: 2, label: "崇左市" },
      ],
    },
    {
      provID: 31563,
      value: 46,
      parentID: 0,
      level: 1,
      label: "海南省",
      children: [
        { cityID: 31564, value: 4601, parentID: 46, level: 2, label: "海口市" },
        { cityID: 31618, value: 4602, parentID: 46, level: 2, label: "三亚市" },
        {
          cityID: 31633,
          value: 4690,
          parentID: 46,
          level: 2,
          label: "省属虚拟市",
        },
      ],
    },
    {
      provID: 31929,
      value: 50,
      parentID: 0,
      level: 1,
      label: "重庆市",
      children: [
        { cityID: 31930, value: 5001, parentID: 50, level: 2, label: "市辖区" },
        { cityID: 32380, value: 5002, parentID: 50, level: 2, label: "县" },
      ],
    },
    {
      provID: 33007,
      value: 51,
      parentID: 0,
      level: 1,
      label: "四川省",
      children: [
        { cityID: 33008, value: 5101, parentID: 51, level: 2, label: "成都市" },
        { cityID: 33344, value: 5103, parentID: 51, level: 2, label: "自贡市" },
        {
          cityID: 33460,
          value: 5104,
          parentID: 51,
          level: 2,
          label: "攀枝花市",
        },
        { cityID: 33528, value: 5105, parentID: 51, level: 2, label: "泸州市" },
        { cityID: 33681, value: 5106, parentID: 51, level: 2, label: "德阳市" },
        { cityID: 33817, value: 5107, parentID: 51, level: 2, label: "绵阳市" },
        { cityID: 34120, value: 5108, parentID: 51, level: 2, label: "广元市" },
        { cityID: 34376, value: 5109, parentID: 51, level: 2, label: "遂宁市" },
        { cityID: 34501, value: 5110, parentID: 51, level: 2, label: "内江市" },
        { cityID: 34628, value: 5111, parentID: 51, level: 2, label: "乐山市" },
        { cityID: 34859, value: 5113, parentID: 51, level: 2, label: "南充市" },
        { cityID: 35288, value: 5114, parentID: 51, level: 2, label: "眉山市" },
        { cityID: 35427, value: 5115, parentID: 51, level: 2, label: "宜宾市" },
        { cityID: 35625, value: 5116, parentID: 51, level: 2, label: "广安市" },
        { cityID: 35813, value: 5117, parentID: 51, level: 2, label: "达州市" },
        { cityID: 36136, value: 5118, parentID: 51, level: 2, label: "雅安市" },
        { cityID: 36299, value: 5119, parentID: 51, level: 2, label: "巴中市" },
        { cityID: 36497, value: 5120, parentID: 51, level: 2, label: "资阳市" },
        { cityID: 36679, value: 5132, parentID: 51, level: 2, label: "阿坝州" },
        {
          cityID: 36926,
          value: 5133,
          parentID: 51,
          level: 2,
          label: "甘孜藏族自治州",
        },
        { cityID: 37270, value: 5134, parentID: 51, level: 2, label: "凉山州" },
      ],
    },
    {
      provID: 37906,
      value: 52,
      parentID: 0,
      level: 1,
      label: "贵州省",
      children: [
        { cityID: 37907, value: 5201, parentID: 52, level: 2, label: "贵阳市" },
        {
          cityID: 38042,
          value: 5202,
          parentID: 52,
          level: 2,
          label: "六盘水市",
        },
        { cityID: 38145, value: 5203, parentID: 52, level: 2, label: "遵义市" },
        { cityID: 38402, value: 5204, parentID: 52, level: 2, label: "安顺市" },
        {
          cityID: 38497,
          value: 5222,
          parentID: 52,
          level: 2,
          label: "铜仁地区",
        },
        {
          cityID: 38677,
          value: 5223,
          parentID: 52,
          level: 2,
          label: "黔西南州",
        },
        {
          cityID: 38816,
          value: 5224,
          parentID: 52,
          level: 2,
          label: "毕节地区",
        },
        {
          cityID: 39075,
          value: 5226,
          parentID: 52,
          level: 2,
          label: "黔东南苗族侗族自治州",
        },
        {
          cityID: 39302,
          value: 5227,
          parentID: 52,
          level: 2,
          label: "黔南布依族苗族自治州",
        },
      ],
    },
    {
      provID: 39556,
      value: 53,
      parentID: 0,
      level: 1,
      label: "云南省",
      children: [
        { cityID: 39557, value: 5301, parentID: 53, level: 2, label: "昆明市" },
        { cityID: 39710, value: 5303, parentID: 53, level: 2, label: "曲靖市" },
        { cityID: 39836, value: 5304, parentID: 53, level: 2, label: "玉溪市" },
        { cityID: 39923, value: 5305, parentID: 53, level: 2, label: "保山市" },
        { cityID: 40004, value: 5306, parentID: 53, level: 2, label: "昭通市" },
        { cityID: 40160, value: 5307, parentID: 53, level: 2, label: "丽江市" },
        { cityID: 40230, value: 5308, parentID: 53, level: 2, label: "思茅市" },
        { cityID: 40348, value: 5309, parentID: 53, level: 2, label: "临沧市" },
        { cityID: 40441, value: 5323, parentID: 53, level: 2, label: "楚雄州" },
        { cityID: 40555, value: 5325, parentID: 53, level: 2, label: "红河州" },
        { cityID: 40705, value: 5326, parentID: 53, level: 2, label: "文山州" },
        {
          cityID: 40816,
          value: 5328,
          parentID: 53,
          level: 2,
          label: "西双版纳州",
        },
        { cityID: 40852, value: 5329, parentID: 53, level: 2, label: "大理州" },
        { cityID: 40979, value: 5331, parentID: 53, level: 2, label: "德宏州" },
        { cityID: 41036, value: 5333, parentID: 53, level: 2, label: "怒江州" },
        { cityID: 41070, value: 5334, parentID: 53, level: 2, label: "迪庆州" },
      ],
    },
    {
      provID: 41103,
      value: 54,
      parentID: 0,
      level: 1,
      label: "西藏自治区",
      children: [
        { cityID: 41104, value: 5401, parentID: 54, level: 2, label: "拉萨市" },
        {
          cityID: 41178,
          value: 5421,
          parentID: 54,
          level: 2,
          label: "昌都地区",
        },
        {
          cityID: 41328,
          value: 5422,
          parentID: 54,
          level: 2,
          label: "山南地区",
        },
        {
          cityID: 41423,
          value: 5423,
          parentID: 54,
          level: 2,
          label: "日喀则地区",
        },
        {
          cityID: 41645,
          value: 5424,
          parentID: 54,
          level: 2,
          label: "那曲地区",
        },
        {
          cityID: 41770,
          value: 5425,
          parentID: 54,
          level: 2,
          label: "阿里地区",
        },
        {
          cityID: 41814,
          value: 5426,
          parentID: 54,
          level: 2,
          label: "林芝地区",
        },
      ],
    },
    {
      provID: 41877,
      value: 61,
      parentID: 0,
      level: 1,
      label: "陕西省",
      children: [
        { cityID: 41878, value: 6101, parentID: 61, level: 2, label: "西安市" },
        { cityID: 42069, value: 6102, parentID: 61, level: 2, label: "铜川市" },
        { cityID: 42119, value: 6103, parentID: 61, level: 2, label: "宝鸡市" },
        { cityID: 42287, value: 6104, parentID: 61, level: 2, label: "咸阳市" },
        { cityID: 42490, value: 6105, parentID: 61, level: 2, label: "渭南市" },
        { cityID: 42703, value: 6106, parentID: 61, level: 2, label: "延安市" },
        { cityID: 42888, value: 6107, parentID: 61, level: 2, label: "汉中市" },
        { cityID: 43136, value: 6108, parentID: 61, level: 2, label: "榆林市" },
        { cityID: 43379, value: 6109, parentID: 61, level: 2, label: "安康市" },
        { cityID: 43592, value: 6110, parentID: 61, level: 2, label: "商洛市" },
      ],
    },
    {
      provID: 43776,
      value: 62,
      parentID: 0,
      level: 1,
      label: "甘肃省",
      children: [
        { cityID: 43777, value: 6201, parentID: 62, level: 2, label: "兰州市" },
        {
          cityID: 43904,
          value: 6202,
          parentID: 62,
          level: 2,
          label: "嘉峪关市",
        },
        { cityID: 43914, value: 6203, parentID: 62, level: 2, label: "金昌市" },
        { cityID: 43936, value: 6204, parentID: 62, level: 2, label: "白银市" },
        { cityID: 44022, value: 6205, parentID: 62, level: 2, label: "天水市" },
        { cityID: 44154, value: 6206, parentID: 62, level: 2, label: "武威市" },
        { cityID: 44265, value: 6207, parentID: 62, level: 2, label: "张掖市" },
        { cityID: 44352, value: 6208, parentID: 62, level: 2, label: "平凉市" },
        { cityID: 44477, value: 6209, parentID: 62, level: 2, label: "酒泉市" },
        { cityID: 44569, value: 6210, parentID: 62, level: 2, label: "庆阳市" },
        { cityID: 44699, value: 6211, parentID: 62, level: 2, label: "定西市" },
        { cityID: 44829, value: 6212, parentID: 62, level: 2, label: "陇南市" },
        { cityID: 45035, value: 6229, parentID: 62, level: 2, label: "临夏州" },
        { cityID: 45174, value: 6230, parentID: 62, level: 2, label: "甘南州" },
      ],
    },
    {
      provID: 45286,
      value: 63,
      parentID: 0,
      level: 1,
      label: "青海省",
      children: [
        { cityID: 45287, value: 6301, parentID: 63, level: 2, label: "西宁市" },
        {
          cityID: 45368,
          value: 6321,
          parentID: 63,
          level: 2,
          label: "海东地区",
        },
        { cityID: 45471, value: 6322, parentID: 63, level: 2, label: "海北州" },
        { cityID: 45510, value: 6323, parentID: 63, level: 2, label: "黄南州" },
        { cityID: 45548, value: 6325, parentID: 63, level: 2, label: "海南州" },
        { cityID: 45597, value: 6326, parentID: 63, level: 2, label: "果洛州" },
        { cityID: 45648, value: 6327, parentID: 63, level: 2, label: "玉树州" },
        { cityID: 45701, value: 6328, parentID: 63, level: 2, label: "海西州" },
      ],
    },
    {
      provID: 45753,
      value: 64,
      parentID: 0,
      level: 1,
      label: "宁夏回族自治区",
      children: [
        { cityID: 45754, value: 6401, parentID: 64, level: 2, label: "银川市" },
        {
          cityID: 45825,
          value: 6402,
          parentID: 64,
          level: 2,
          label: "石嘴山市",
        },
        { cityID: 45871, value: 6403, parentID: 64, level: 2, label: "吴忠市" },
        { cityID: 45926, value: 6404, parentID: 64, level: 2, label: "固原市" },
        { cityID: 45999, value: 6405, parentID: 64, level: 2, label: "中卫市" },
      ],
    },
    {
      provID: 46047,
      value: 65,
      parentID: 0,
      level: 1,
      label: "新疆维吾尔自治区",
      children: [
        {
          cityID: 46048,
          value: 6501,
          parentID: 65,
          level: 2,
          label: "乌鲁木齐市",
        },
        {
          cityID: 46138,
          value: 6502,
          parentID: 65,
          level: 2,
          label: "克拉玛依市",
        },
        {
          cityID: 46162,
          value: 6521,
          parentID: 65,
          level: 2,
          label: "吐鲁番地区",
        },
        {
          cityID: 46197,
          value: 6522,
          parentID: 65,
          level: 2,
          label: "哈密地区",
        },
        { cityID: 46255, value: 6523, parentID: 65, level: 2, label: "昌吉州" },
        {
          cityID: 46380,
          value: 6527,
          parentID: 65,
          level: 2,
          label: "博尔塔拉蒙古自治州",
        },
        {
          cityID: 46422,
          value: 6528,
          parentID: 65,
          level: 2,
          label: "巴音郭楞蒙古自治州",
        },
        {
          cityID: 46551,
          value: 6529,
          parentID: 65,
          level: 2,
          label: "阿克苏地区",
        },
        { cityID: 46688, value: 6530, parentID: 65, level: 2, label: "克州" },
        {
          cityID: 46747,
          value: 6531,
          parentID: 65,
          level: 2,
          label: "喀什地区",
        },
        {
          cityID: 46957,
          value: 6532,
          parentID: 65,
          level: 2,
          label: "和田地区",
        },
        { cityID: 47069, value: 6540, parentID: 65, level: 2, label: "伊犁州" },
        {
          cityID: 47241,
          value: 6542,
          parentID: 65,
          level: 2,
          label: "塔城地区",
        },
        {
          cityID: 47374,
          value: 6543,
          parentID: 65,
          level: 2,
          label: "阿勒泰地区",
        },
        {
          cityID: 47450,
          value: 6590,
          parentID: 65,
          level: 2,
          label: "省直辖行政单位",
        },
      ],
    },
    { provID: 47493, value: 71, parentID: 0, level: 1, label: "台湾省" },
    {
      provID: 47494,
      value: 81,
      parentID: 0,
      level: 1,
      label: "香港特别行政区",
    },
    {
      provID: 47495,
      value: 82,
      parentID: 0,
      level: 1,
      label: "澳门特别行政区",
    },
  ],
};